import { BannerKey, BannerType } from 'features/banner/model/banner';
import { useDismissBanner } from 'hooks/dismiss-banner/useDismissBanner';
import { useTranslation } from 'react-i18next';
import { UpsellCardHeader } from './components/UpsellCardHeader';
import { UpsellCardSpotlight } from './components/UpsellCardSpotlight';
import { UpsellCardDismiss, UpsellCardProps } from './models/upsell-card-props';

export const UpsellCard: React.FC<UpsellCardProps> = ({ position, dismiss, action, ...props }) => {
    const { t } = useTranslation();
    const { onDismiss, isDissmissed } = useDismissBanner(
        position !== undefined ? { key: BannerKey.UPSELL_CARD, position, index: 0, type: BannerType.CUSTOM } : undefined
    );

    if (position !== undefined && isDissmissed) {
        return null;
    }

    const resolvedDismiss: UpsellCardDismiss | undefined =
        dismiss ?? (position !== undefined ? { onClick: onDismiss, accessibilityLabel: t('BUTTON.CLOSE') } : undefined);

    return props.variant === 'spotlight' ? (
        <UpsellCardSpotlight {...props} action={action} dismiss={resolvedDismiss} />
    ) : (
        <UpsellCardHeader {...props} action={action} dismiss={resolvedDismiss} />
    );
};
